'use client';

import { SessionProvider } from 'next-auth/react';

const AuthProvider = SessionProvider;

export { AuthProvider };
